import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SubscriptionsPageComponent } from './subscriptions-page/subscriptions-page.component';
import { SubscriptionsFilterComponent } from './subscriptions-filter/subscriptions-filter.component';
import { SharedModule } from '../../../shared/shared.module';
import { ActivateSubscriptionModalComponent } from '../activate-subscription-modal/activate-subscription-modal.component';
import { OpenActivateSubscriptionModalDirective } from '../activate-subscription-modal/open-activate-subscription-modal.directive';
import { ModalModule } from '../../../core/modal/modal.module';
import { SubscriptionsRoutingModule } from './subscriptions-routing.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatTooltipModule,
    ModalModule,
    TranslateModule,
    SubscriptionsRoutingModule,
  ],
  exports: [
    OpenActivateSubscriptionModalDirective,
  ],
  declarations: [
    ActivateSubscriptionModalComponent,
    OpenActivateSubscriptionModalDirective,
    SubscriptionsPageComponent,
    SubscriptionsFilterComponent,
  ],
  providers: [],
})
export class SubscriptionsModule {
}
